export class FormatTime {
  public static timeInMinAndSec(totalSeconds: number): { minutes: number; seconds: number } {
    return { minutes: Math.floor(totalSeconds / 60) % 60, seconds: Math.floor(totalSeconds) % 60 };
  }

  public static timeToMMSS(ft: { minutes: number; seconds: number }): string {
    return `${ft.minutes.toString().padStart(2, '0')}:${ft.seconds.toString().padStart(2, '0')}`;
  }
}
